module.exports = __webpack_public_path__ + "static/media/Non-food.d334cd76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Non-food.png
// module id = 339
// module chunks = 0